export default {
    allRightsReserved:'EVT Legajo 11.736. Todos los derechos reservados.',
}